export const safeJsonParse = (str, fallback = null) => {
  try {
    return str ? JSON.parse(str) : fallback;
  } catch {
    return fallback;
  }
};

export const decodeJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Error decoding JWT:", e);
    return null;
  }
};

// Enhanced hasPermission with wildcard support (*.View, Module.*)
export const hasPermission = (permissions, permission) => {
  if (!Array.isArray(permissions) || !permissions.length) return false;

  return permissions.some((p) => {
    // Exact match
    if (p === permission) return true;

    // Permission wildcard (e.g., 'Branch.*' matches 'Branch.View')
    if (p.endsWith(".*") && permission.startsWith(p.slice(0, -2))) {
      return true;
    }

    // User perm is wildcard (less common)
    if (permission.endsWith(".*") && p.startsWith(permission.slice(0, -2))) {
      return true;
    }

    return false;
  });
};
